import type {SuppliedFilterProvider} from '@github-ui/filter-core'
import {ISSUE_TYPE_FILTER_KEY, type IssueTypeFilterProvider} from '@github-ui/issue-type-filter-provider'

export function isTypeFilterProvider(
  filterProvider: SuppliedFilterProvider,
): filterProvider is IssueTypeFilterProvider {
  return 'key' in filterProvider && filterProvider.key === ISSUE_TYPE_FILTER_KEY.key
}
